//exportar todos los inputs
export * from "./heading-text-input";
export * from "./button-input";
export * from "./base-text-input";
export * from "./image-input";
export * from "./list-input";
export * from "./video-input";
export * from "./magic-container-input";


